export default "__VITE_ASSET__f53QytUs__"